import { HtmlContent, WorkspaceGroup, WorkspaceSchemeName } from '../common/workspaceScheme/types';
import { MapObject } from '../../types/general';


export enum WorkspaceTypeKeys {
    WORKSPACE_SCHEME_LOADED = 'workspace/WORKSPACE_SCHEME_LOADED',
    WORKSPACE_SCHEME_ERROR = 'workspace/WORKSPACE_SCHEME_ERROR',
    WORKSPACE_PRESET_LOADED = 'workspace/WORKSPACE_PRESET_LOADED',
    SETUP_GENERIC_FEATURES_STATE = 'workspace/SETUP_GENERIC_FEATURES_STATE',
    TOGGLE_HEADER = 'generic/TOGGLE_HEADER',
    TOGGLE_EXPAND = 'workspace/TOGGLE_EXPAND',
    SET_FEATURE_LOADING = 'workspace/SET_FEATURE_LOADING',
    STOP_FEATURE_LOADING = 'workspace/STOP_FEATURE_LOADING',
    TOGGLE_FOCUS_MODE = 'workspace/TOGGLE_FOCUS_MODE',
    SET_FEATURE_STATUS_INDICATOR = 'workspace/SET_FEATURE_STATUS_INDICATOR',
    FEATURES_SETUP_DONE = 'workspace/FEATURES_SETUP_DONE',
    TOGGLE_FULL_SCREEN = 'workspace/TOGGLE_FULL_SCREEN',
    FEATURE_LOADED = 'workspace/FEATURE_LOADED',
    SET_CONTEXT_MENU_VISIBILITY = 'workspace/SET_CONTEXT_MENU_VISIBILITY',
    SET_ACTIVE_OVERLAY = 'workspace/SET_ACTIVE_OVERLAY',
    RESET_ACTIVE_OVERLAY = 'workspace/RESET_ACTIVE_OVERLAY',
    SET_PRINT_MODE = 'workspace/SET_PRINT_MODE',
    SET_WORKSPACE_OVERLAY = 'workspace/SET_WORKSPACE_OVERLAY',
    CLOSE_WORKSPACE_OVERLAY = 'workspace/CLOSE_WORKSPACE_OVERLAY',
    SET_CONTEXT_REQUIRED_PROPERTIES = 'workspace/SET_CONTEXT_REQUIRED_PROPERTIES',
    RESET_CONTEXT_REQUIRED_PROPERTIES = 'workspace/RESET_CONTEXT_REQUIRED_PROPERTIES',
    WILL_CHANGE_WORKSPACE_ID = 'workspace/WILL_CHANGE_WORKSPACE_ID',
    TOGGLE_SIDE_BAR = 'workspace/TOGGLE_SIDE_BAR',
    TOGGLE_STRUCTURE_EDITOR = 'workspace/TOGGLE_STRUCTURE_EDITOR',
    OPEN_CURRENT_CONTEXT_IN_SPLIT = 'workspace/OPEN_CURRENT_CONTEXT_IN_SPLIT',
    OPEN_ITEM_IN_SPLIT_VIEW = 'workspace/OPEN_ITEM_IN_SPLIT_VIEW',
    IS_CLOSED_CLICKED = 'workspace/IS_CLOSED_CLICKED',
    HAS_BEEN_EDITED = 'workspace/HAS_BEEN_EDITED',
    CREATE_PRINT_EVENT_MESSAGE = 'workspace/CREATE_PRINT_EVENT_MESSAGE',
}

export enum WorkspaceOverlaySizeOptions {
    FULLSCREEN_OVERLAY = 'FULLSCREEN_OVERLAY',
    MIDSIZED_CENTERED_OVERLAY = 'MIDSIZED_CENTERED_OVERLAY',
}

export type WorkspaceOverlaySize =
    WorkspaceOverlaySizeOptions.FULLSCREEN_OVERLAY | WorkspaceOverlaySizeOptions.MIDSIZED_CENTERED_OVERLAY;

export type WorkspaceOverlayConfiguration = {
    options?: any;
    context?: any;
    workspaceTitle?: string;
    workspaceSecondaryTitle?: string;
    workspaceOverlaySize?: WorkspaceOverlaySize;
    onClose?: () => void;
    onReady?: () => void;
};

export type WorkspaceHeader = {
    showHeader: boolean;
    customHeaderFeature?: string;
    options: { [key: string]: any };
    enableWorkspaceBreadcrumbs?: boolean;
    navigationInHeader?: boolean;
    headerWidgets: string[];
}

export type FeatureConfig = {
    type: string;
    options: MapObject;
};

export type ColumnConfig = {
    features: FeatureConfig[];
}

export type FooterOptions = {
    withHeader?: boolean;
    showFocusMode?: true;
    showFullScreen?: true;
    navigationItems?: { [key: string]: any }[];
}

export type FooterConfig = {
    showFooter: boolean;
    options?: FooterOptions;
}

export type WorkspacePreset = {
    layout: number[];
    footer: FooterConfig;
    main: ColumnConfig[];
    workspaceHeader?: WorkspaceHeader;
    header?: any;
};

export enum WorkspacesOverlayTypes {
    PREVIEW_AND_COMPARE = 'previewAndCompare',
    ADD_QUESTIONS = 'addQuestions',
    COLUMN_PICKER = 'columnPicker',
    DOWNLOAD_AND_PRINT = 'downloadAndPrint',
    QUESTION_TEST_CASES_OVERLAY = 'questionTestCases',
    DYNAMIC_ANSWER_KEYS = 'dynamicAnswerKeys',
    WORKFLOW_OVERLAY = 'workflowOverlay',
    EXPLANATION_OF_GRADES = 'explanationOfGrades',
    SUBMISSION = 'submission',
    HTML_VIEW = 'htmlView',
    COMMITTEE_SELECTOR = 'committeeSelector',
    PHASE_SELECTOR = 'phaseSelector',
    WORKFLOW_SETTINGS = 'workflowSettings',
    POSSIBLE_ISSUES = 'possibleIssues',
    FEEDBACK_STUDIO_DISPLAY = 'feedbackStudioDisplay',
    RUBRIC_OVERLAY = 'rubricOverlay',
    CROSS_TEST_METRICS = 'crossTestMetrics',
    ATTEMPTS_SETUP = 'attemptsSetup',
    ATC_CONTENT_BLOCKS_USAGE_LISTS = 'seeAtcUsage',
    STIMULUS_LAYOUTS = 'stimulusLayouts',
    CANVAS_BACKGROUND_EDITOR = 'canvasBackgroundEditor',
    ADD_STIMULUS_FROM_BANK = 'addStimulusFromBank',
    QUESTION_DELIVERY = 'questionDelivery',
    CONTENT_BLOCK_DELIVERY = 'contentBlockDelivery',
    EDIT_RUBRICS_OVERLAY = 'editRubricsOverlay',
    RUBRICS_TEMPLATES_LIST_MODAL = 'rubricsTemplatesListModal',
    THRESHOLD_SCORING_OVERLAY = 'thresholdScoringOverlay',
    QUESTION_SET_SUMMARY = 'questionSetSummary',
}

export enum WorkspacesOverlayTargets {
    APP_OVERLAY_TARGET = 'appOverlayTarget',
    WORKSPACE_OVERLAY_TARGET = 'workspaceOverlayTarget',
}

export const PRINT_ANNOTATIONS_ONLY_WORKSPACE = 'evaluate_list_comments';

export interface WorkflowKey {
    id: string;
    key: string;
}

export interface WorkspaceSchemeModel {
    schemeId: string;
    name: WorkspaceSchemeName;
    workspaceGroups: WorkspaceGroup[];
    htmlContents: HtmlContent[];
    workflowKeys?: WorkflowKey[];
}

export type FeatureStatusMap = {
    [key: string]: string;
};

export interface WorkspacesSideBar {
    expanded: boolean;
}

export const CREATE_PRINT_EVENT_MESSAGE = 'CREATE_PRINT_EVENT_MESSAGE';

export type SplitPreviewItem = {
    objectId: number;
    objectType: string;
    category?: string;
    orderNumber?: number;
    title?: string;
}
